"use client"

import { Flex } from "@/shared/components/flex"
import { ZentjesLogo } from "@/shared/components/zentjes-logo"
import { Button } from "@/shared/ui/button"
import { ArrowLeft, Home, Search } from "lucide-react"
import Link from "next/link"

const suggestions = [
    { href: "/dashboard", label: "Dashboard", description: "View your financial overview" },
    { href: "/transactions", label: "Transactions", description: "See all your transactions" },
    { href: "/calendar", label: "Calendar", description: "Budget calendar view" },
    { href: "/split", label: "Split Bill", description: "Split expenses with others" },
]

export default function NotFound() {
    return (
        <main
            role="main"
            aria-labelledby="not-found-heading"
            className="min-h-screen bg-background text-foreground flex flex-col items-center justify-center px-6"
        >
            <div className="max-w-lg w-full text-center space-y-8">
                <Flex dir="col" align="center">
                    <ZentjesLogo size="md" id="not-found-logo" />
                </Flex>

                <div className="space-y-3">
                    <h1 id="not-found-heading" className="text-5xl font-bold tracking-tight">
                        404
                    </h1>
                    <h2 className="text-lg font-medium text-muted-foreground">Page not found</h2>
                    <p className="text-sm text-muted-foreground max-w-sm mx-auto">
                        The page you're looking for doesn't exist or may have been moved.
                    </p>
                </div>

                <div
                    className="flex flex-col sm:flex-row gap-3 justify-center"
                    role="group"
                    aria-label="Navigation actions"
                >
                    <Button
                        onClick={() => window.history.back()}
                        variant="outline"
                        className="gap-2"
                    >
                        <ArrowLeft className="h-4 w-4" aria-hidden="true" />
                        Go Back
                    </Button>
                    <Button asChild variant="default" className="gap-2">
                        <Link href="/dashboard">
                            <Home className="h-4 w-4" aria-hidden="true" />
                            Dashboard
                        </Link>
                    </Button>
                </div>

                <nav className="pt-6 border-t border-border" aria-label="Suggested pages">
                    <p className="text-xs text-muted-foreground mb-4 flex items-center justify-center gap-1.5">
                        <Search className="h-3 w-3" aria-hidden="true" />
                        Looking for one of these?
                    </p>
                    <div className="grid grid-cols-2 gap-2">
                        {suggestions.map((item) => (
                            <Link
                                key={item.href}
                                href={item.href}
                                className="group p-3 rounded-lg border border-border hover:border-ring hover:bg-accent/50 transition-colors text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                            >
                                <p className="text-sm font-medium text-foreground group-hover:text-foreground transition-colors">
                                    {item.label}
                                </p>
                                <p className="text-xs text-muted-foreground group-hover:text-muted-foreground transition-colors">
                                    {item.description}
                                </p>
                            </Link>
                        ))}
                    </div>
                </nav>
            </div>
        </main>
    )
}
